<template>
  <div class="bg-color">
    <div class="wrapper clearFix">
      <!--Left模块-->
      <div class="left">
        <dl class="lt-menu">
          <dt>混改服务</dt>
          <dd class="XWZX">
            <router-link to='/author'>新闻资讯</router-link>
          </dd>
          <dd class="ZCFG">
            <router-link to='/policy'>政策法规</router-link>
          </dd>
          <dd class="ALFX">
            <router-link to='/case'>案例分析</router-link>
          </dd>
          <dd class="RHCY">
            <router-link to='/partake'>如何参与</router-link>
          </dd>
          <dd class="CJWT">
            <router-link to='/problem'>常见问题</router-link>
          </dd>
        </dl>

      </div>
      <!--End:Left模块-->
      <!--Right模块-->
      <div class="right">
        <div class="article">
          <div class="title">
            <h2>{{serviceDetail.title}}</h2>
            <div class="time-author">
              <span class="newstime">{{serviceDetail.updatetime|dateFormat}}</span>
            </div>
          </div>
          <div class="service-content" v-html="serviceDetail.content">
          </div>
        </div>
      </div>
      <!--End:Right模块-->
    </div>
  </div>
</template>

<style scoped>
  @import "../style/service.css";
</style>

<script>
import { mapState } from 'vuex'
import global from '../components/public/Common.vue';
export default {
  name: 'author',
  data() {
    return {
      serviceUrl:global.serviceUrl,
      token:global.token,

      serviceDetail: ''
    }
  },
  created: function () {
    let _this = this;
    var id = _this.$route.query.id;
    var catid = _this.$route.query.catid;
    loadData(_this,id,catid,this.serviceUrl,this.token);
  },
  updated:function () {
    var catid = this.$route.query.catid;
    change(catid);
    //设置新闻中图片居中
    $(".service-content img").css({"display":"block","margin":"auto"})
  },
  mounted:function(){

  },
  watch: {
     //利用watch方法检测路由变化：
    '$route': function (to, from) {
      // 拿到目标参数 to.query.id 去再次请求数据接口
      loadData(this,to.query.id,to.query.catid,this.serviceUrl,this.token);
      change(to.query.catid);
    }
  },
  methods: {

  },
  filters: {
    dateFormat:function(time) {
      return global.dateFormatYmd(time)
    },
  },


}
function loadData(tar,id,catid,url,token) {
  $.ajax({
    url: url,
    type: 'post',
    dataType: 'jsonp',
    data: {
      'token':token,
      'id':id,
      'catid':catid
    },
    success: function (data) {
      if (data.msg == 200) {
        //console.log(data);
        tar.serviceDetail = data.result[0];
      } else {
        alert(data.msg);
      }
    },
    error: function (data) {

    }
  });
}
function change(val) {
  if (val == 12) {
    $(".lt-menu dd.on").removeClass("on");
    $(".lt-menu dd.XWZX").addClass("on");
    return "新闻资讯";
  } else if (val == 38) {
    $(".lt-menu dd.on").removeClass("on");
    $(".lt-menu dd.ZCFG").addClass("on");
    return "政策法规";
  }else if (val == 13) {
    $(".lt-menu dd.on").removeClass("on");
    $(".lt-menu dd.ALFX").addClass("on");
    return "案例分析";
  }else if (val == 42) {
    $(".lt-menu dd.on").removeClass("on");
    $(".lt-menu dd.RHCY").addClass("on");
    return "如何参与";
  }else if (val == 43) {
    $(".lt-menu dd.on").removeClass("on");
    $(".lt-menu dd.CJWT").addClass("on");
    return "常见问题";
  }
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/ServiceDetail.vue